import axios from 'axios';
import { Image } from './image';

export interface ImageIndexFilters {
  course_id: number;
  course_name: string;
}

export interface ImageIndexOptions {
  itemsPerPage: number;
  sortBy: string[];
  sortDesc: boolean[];
  page: number;
  filters: ImageIndexFilters;
}

export class ImageIndex {
  public static PER_PAGE: number = 30;

  public static async getCount(
    filters?: ImageIndexFilters,
  ): Promise<any> {
    return axios.get('/api/images/count', {
      params: {
        filters,
      },
    });
  }

  public static async getData(
    ImageIndexOptions?: ImageIndexOptions,
  ): Promise<any> {
    if (ImageIndexOptions == null) {
      return axios.get('/api/images/index', {
        params: {
          per_page: this.PER_PAGE,
        },
      });
    }

    const perPage =
      ImageIndexOptions.itemsPerPage <= 0
        ? this.PER_PAGE
        : ImageIndexOptions.itemsPerPage;
    return axios.get('/api/images/index', {
      params: {
        per_page: perPage,
        sort_fields: ImageIndexOptions.sortBy,
        sort_desc: ImageIndexOptions.sortDesc,
        page: ImageIndexOptions.page,
        filters: ImageIndexOptions.filters,
      },
    });
  }

  public static parseResponse(response: any): Image[] {
    const imageData = [] as Image[];
    for (const k in response) {
      if (!response[k]) {
        continue;
      }
      const item = response[k];
      const image = {} as Image;
      image.id = item.id;
      image.course_id = item.course_id;
      image.course_name = item.course_name;
      imageData.push(image);
    }
    return imageData;
  }
}
